import { ReactNode } from 'react';

import {
  CustomModal,
  CustomModalBody,
  CustomModalFooter,
  CustomModalHeader,
  CustomModalProps,
  CustomModalTitle,
} from 'src/components/custom_components/CustomModal';

export interface SmallModalTemplateProps extends Omit<
  CustomModalProps,
  'children'
> {
  icon: ReactNode;
  iconWrapperClassName: string;
  title: string;
  description: string;
  card?: ReactNode;
  leftButton?: ReactNode;
  rightButton: ReactNode;
}

export default function SmallModalTemplate({
  icon,
  iconWrapperClassName,
  title,
  description,
  card,
  leftButton,
  rightButton,
  ...modalProps
}: SmallModalTemplateProps) {
  return (
    <CustomModal {...modalProps}>
      <CustomModalHeader className="flex-column align-items-start px-4 pt-4 pb-0">
        <div
          className={`d-inline-flex align-items-center justify-content-center rounded p-3 mb-2 ${iconWrapperClassName}`}
        >
          {icon}
        </div>
        <CustomModalTitle data-test="small-modal-title">
          {title}
        </CustomModalTitle>
      </CustomModalHeader>
      <CustomModalBody className="px-4 pt-2 pb-2">
        <p data-test="small-modal-description">{description}</p>
        {card}
      </CustomModalBody>
      <CustomModalFooter className="px-4 pb-4">
        {leftButton}
        <span className="ms-auto">{rightButton}</span>
      </CustomModalFooter>
    </CustomModal>
  );
}
